import classNames from "classnames";
import { Link, LinkProps } from "react-router-dom";
import styles from "./StyledLinkButton.module.css";

type Props = LinkProps & {
  disabled?: boolean;
};

export function StyledLinkButton({
  children,
  className,
  disabled,
  ...rest
}: Props) {
  const finalClassName = classNames(
    styles.container,
    className,
    disabled ? styles.disabled : null,
  );

  return (
    <Link className={finalClassName} {...rest}>
      {children}
    </Link>
  );
}
